import React, {useState, useEffect} from 'react'
import Breadcumb from '../../../components/Breadcumb/Breadcumb'
import { Container, Card, CardContent, Grid, TextField, Button, FormControl, Select, InputLabel, MenuItem } from '@material-ui/core'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { useDropzone } from 'react-dropzone';
import { Categories, Alerts } from '../../../helpers';
import { useParams } from 'react-router-dom';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import { Link } from 'react-router-dom';
const BreadcrumbData = [
  {
    id: 1,
    page_title: "Dashboard",
    page_path: "/",
    icon: "tachometer",
  },
  {
    id: 2,
    page_title: "Create Category",
    page_path: "/",
    icon: "tachometer",
  }
]
const CategoryEdit = () => {
  const { id } = useParams();
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState(null);
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [parent_id, setSetParentId] = useState(0);
  const [isHome, setHome] = useState(0);
  const [is_popular, setIsPopular] = useState(0);
  

  let files = acceptedFiles.map(file => (
    <li key={file.name}>
      {file.name} - {file.size} bytes
    </li>
  ));
const getCategoriesData = async () =>{
  let resp = await Categories.getCategories();
  let resp2 = await Categories.getSingleCategory(id);

   if(resp && resp.status){
    setCategories(resp.categories);
   }
   if(resp2){
    if(resp2.status){
        setCategory(resp2.category)
        setName(resp2.category.name);
        setDescription(resp2.category.description);
        setHome(resp2.category.isHome);
        setIsPopular(resp2.category.is_popular);
        if(resp2.category.parent_id !== null){
            setSetParentId(resp2.category.parent.id);
        }
      }
  }
}
  useEffect(()=>{
    getCategoriesData();
  },[])

  const handleSubmit = async (e) =>{
      e.preventDefault();
      var data = {
        name:name,
        description:description,
        isHome:isHome,
        is_popular:is_popular
      }
      if(parent_id !== 0){
        data.parent_id = parent_id;
      }
      let resp = await Categories.updateCategory(id, data);
      if(resp){
        if(resp.status){
          Alerts.alertMessage(resp.message, '', 'success')
        }else{
          Alerts.alertMessage(resp.message, '', 'danger')
        }
      }
  }

  const removeThumbnail = async(id) =>{
    let resp = await Categories.removeCategoryThumb(id);
    if(resp){
      window.location.reload();
    }
  }

  const addNewThumbnail = async() =>{
    let formData = new FormData()
    for (let i = 0; i < acceptedFiles.length; i++) {
        formData.append("images", acceptedFiles[i]);
    }
    let resp = await Categories.addNewCategoryThumbnail(id, formData);
    if(resp){
      if(resp.status){
        window.location.reload();
      }
     
    }
  }
  return (
    <>
      <Breadcumb items={BreadcrumbData} />
      <div className="page-wrapper pd30">
        <Container>
          <Card className="card">
            <CardContent>
            <div className='page-inner-header'>
                <h3 className='m-0'>Update Category</h3>
                <Link to={`/app/categories`} className="btn-primary action-btn">
                  Categories
                </Link>
              </div>
              {
                category !== null &&  
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                  <form onSubmit={handleSubmit} enctype='multipart/form-data'>
                    <div className='form-group'>
                      <TextField
                        label="Name"
                        variant="outlined"
                        fullWidth
                        size="small"
                        value={name}
                        onChange={(e)=>setName(e.target.value)}
                      />
                    </div>
                    <div className='form-group'>
                      <label className='input-label'>Description</label>
                     
                      <CKEditor
                        editor={ClassicEditor}
                        phase={`initialization`}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setDescription(data);
                        }}
                        onReady={ editor => {
                            editor.setData(description);
                        } }
                     
                      />
                    </div>
                    <div className='form-group'>
                      <FormControl variant="outlined" style={{ width: '100%' }} size="small">
                        <InputLabel id="parent_category">Parent Category</InputLabel>
                        <Select
                          labelId="parent_category"
                          label="Parent Category"
                          onChange={(e)=>setSetParentId(e.target.value)}
                          value={parent_id}
                        >
                          <MenuItem value="">
                            <em>--Select Category--</em>
                          </MenuItem>
                          {
                            categories && categories.length !== 0 && categories.map((item, i)=>{
                              return <MenuItem value={item.id} selected={parent_id === item.id}>{item.name}</MenuItem>
                            })
                          }
                        </Select>
                      </FormControl>
                    </div>
                    <div className='form-group'>
                      <FormControl variant="outlined" style={{ width: '100%' }} size="small">
                        <InputLabel id="show_on_home">Show On Home</InputLabel>
                        <Select
                          labelId="show_on_home"
                          label="Show On Home"
                          onChange={(e)=>setHome(e.target.value)}
                          value={isHome}
                        >
                          <MenuItem value={1} selected={isHome === 1}>Yes</MenuItem>
                          <MenuItem value={0} selected={isHome === 0}>No</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <div className='form-group'>
                      <FormControl variant="outlined" style={{ width: '100%' }} size="small">
                        <InputLabel id="popular_category">Popular Category</InputLabel>
                        <Select
                          labelId="popular_category"
                          label="Popular Category"
                          onChange={(e)=>setIsPopular(e.target.value)}
                          value={is_popular}
                        >
                          <MenuItem value={1} selected={is_popular === 1}>Yes</MenuItem>
                          <MenuItem value={0} selected={is_popular === 0}>No</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <Button type='submit' variant="contained" color="primary">
                  Submit
                </Button>
              </form>
                  </Grid>
                  <Grid item xs={6}>
                     <div className='image-greed'>
                   
                            {
                              category.category_images.map((item,i)=>{
                                return <div className='category_image_wrapper' key={i}> 
                                <div className='category_image'>
                                  <img src={item.image_url} alt=""/>
                                 
                                </div>
                                <button onClick={()=>removeThumbnail(item.id)}><RemoveCircleIcon fontSize="small"/></button>
                                 </div>
                                 
                              })
                            }
                       
                     </div>
                     <label className='input-label'>Add New Thumbnails</label>
                     <section className="container">
                      <div {...getRootProps({ className: 'dropzone disabled' })}>
                        <input {...getInputProps()} />
                        <p>Drag 'n' drop some files here, or click to select files</p>
                      </div>
                      <aside>
                        <h6 style={{ margin: 10 }}>Files</h6>
                        <ul>{files}</ul>
                      </aside>
                    </section>
                    <Button type='button' onClick={addNewThumbnail} variant="contained" color="primary">
                  Submit
                </Button>
                  </Grid>
                </Grid>

               
              }
             
            </CardContent>
          </Card>
        </Container>
      </div>

    </>
  )
}

export default CategoryEdit